<template>
  <svg class="hamburger-menu" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="#000000" fill-opacity="0.54">
    <path class="hamburger-menu-bar" d="M0 0h24v24H0z" fill="none"/>
    <path class="hamburger-menu-bar" d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/>
  </svg>
</template>

<script>
  export default {
    name: 'HamburgerMenu'
  }
</script>



// WEBPACK FOOTER //
// src/components/assets/HamburgerMenu.vue